import classnames from 'classnames';
import type { Tab } from './Tabs.v3.types';

interface Props {
	tabs: Tab[];
	selectedTabId: string;
	onSelectedTabIdChange: (id: string) => void;
}

export function TabsButtons({ tabs, selectedTabId, onSelectedTabIdChange }: Props) {
	return (
		<div className="flex">
			{tabs.map((tab) => (
				<div
					key={tab.id}
					data-testid={tab.id}
					className={classnames(
						'w-60 flex items-center justify-center py-3 border-solid rounded font-bold cursor-pointer text-sm mr-2',
						{
							'bg-blue-100 border border-blue-500': selectedTabId === tab.id,
							'bg-gray-100 border border-gray-300 ': selectedTabId !== tab.id,
						}
					)}
					style={{ textAlign: 'center' }}
					onClick={() => onSelectedTabIdChange(tab.id)}
				>
					{tab.name}
				</div>
			))}
		</div>
	);
}
